import React, { Component } from 'react';
import aiIconBlue from '../../../styles/images/new-ai-logo-blue.svg';
import aiIconBlack from '../../../styles/images/new-ai-logo-black.svg';
import aiIconWhite from '../../../styles/images/new-ai-logo-white.svg';
import aiIconDarkBlue from '../../../styles/images/new-ai-logo-darkblue.svg';
import newAiIcon from '../../../styles/images/new-ai-logo.svg';


export default class AIAssistantIcon extends Component {

    render() {

        let src = ""

        if (this.props.color === "blue") {
            if (this.props.theme.type === "normal")
                src = aiIconDarkBlue
            else
                src = aiIconBlue
        }else if (this.props.color === "new") {
            src = newAiIcon
        } else {
            if (this.props.theme.type === "normal")
                src = aiIconBlack
            else
                src = aiIconWhite
        }

        return (
            <img style={this.props.style} src={src} height={this.props.height} />
        )
    }
}